import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FaqItem extends Component {
  render() {
    const { title, description, id } = this.props;
    const { t } = this.context;

    return (
      <div className="faq-container__item col-md-10 col-sm-12">
        <input type="checkbox" id={id} className="faq-container__item__input-checkbox" />
        <label htmlFor={id} className="faq-container__item__label">
          {t(title)}
        </label>
        <p className="faq-container__item__title">
          <span dangerouslySetInnerHTML={{ __html: t(description) }} />
        </p>
      </div>
    );
  }
}

FaqItem.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default FaqItem;



// WEBPACK FOOTER //
// ./src/app/main/faq/components/faq-item.js